import { useSendGtmEvents } from "./app-shell/providers/gtm-events-provider/gtm-events-provider";
import { toTenantIdHeader, useApiQuery } from "../api/use-api";
import { ME_KEY } from "../types/query-keys";
import { useTenantId } from "../util/use-active-tenant-id";
import { useChangeObserver } from "~/util/hooks";

export const IdentifyUserInGoogleAnalytics: React.FC = () => {
  const tenantId = useTenantId();
  const { data: user } = useApiQuery(
    "backend",
    (api) => api.getMe(toTenantIdHeader(tenantId)),
    ME_KEY(tenantId),
  );

  const { sendIdentifyUserBasedOnId } = useSendGtmEvents();
  useChangeObserver(
    user?.id,
    (user_id) => user_id && sendIdentifyUserBasedOnId({ user_id }),
  );

  return null;
};
